import { render } from "./LandingPageFooter.vue?vue&type=template&id=2fc92e1e&scoped=true"
const script = {}

import "./LandingPageFooter.vue?vue&type=style&index=0&id=2fc92e1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc92e1e"]])

export default __exports__